<svg
  width="12"
  height="1"
  viewBox="0 0 12 1"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
>
  <path id="Vector" d="M0.602051 0.7V0H12.0021V0.7H0.602051Z" fill="white" />
</svg>
